import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const uploadRichPanelMacros = {
  name: "uploadRichPanelMacros" as const,
  input: z.object({
    teamId: zExt.objectId(),
    fileName: z.string(),
    fileContent: z.string(), // base64 encoded file content
    mimeType: z.string(),
  }),
  output: z.object({ importedCount: z.number(), skippedCount: z.number() }),
};
